var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A22E7EB4-FBB8-4D01-AC63-20E282A90055") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-513.000000, -10662.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(60.000000, 10295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(429.000000, 363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sb-icons/24x24/comment",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,4 L22,21.8584816 L16.7464834,17.6707494 L2,17.6707494 L2,4 L22,4 Z M20,6 L4,6 L4,15.6707494 L17.4460776,15.6707494 L20,17.7065559 L20,6 Z M14.6013993,12.0183633 L14.6013993,13.0183633 L8.60139934,13.0183633 L8.60139934,12.0183633 L14.6013993,12.0183633 Z M16.5247157,9.01836325 L16.5247157,10.0183633 L6.60139934,10.0183633 L6.60139934,9.01836325 L16.5247157,9.01836325 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComment);
export default __webpack_public_path__ + "static/media/ico_comment.b329ce536cb0295576c760d90ae840f1.svg";
export { ForwardRef as ReactComponent };